import React, { useEffect, useState } from 'react';
import { Alert, Backdrop, Box, Button, Container, CssBaseline, Drawer, Fade, Modal, Toolbar, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SupervisorSidebar from './sidebar';
import { AccountCircle } from '@mui/icons-material';
import { useAuth } from '../authContext';
import AdminNavigation from './adminNavigation';

const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  textAlign: 'center'
};

const formatDate = (date) => {
  const months = [
    'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
    'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

const PresensiManager = () => {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [time, setTime] = useState(new Date());
  const [message, setMessage] = useState('');
  const now = new Date();
  const formattedDate = formatDate(now);
  const [openLogout, setOpenLogout] = useState(false);
  const handleOpenLogout = () => setOpenLogout(true);
  const handleCloseLogout = () => setOpenLogout(false);
  const { auth, logout } = useAuth();
  const getUsername = auth.user ? auth.user.username : '';

  useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    const storedMessage = localStorage.getItem('berhasilClockIn');
    if (storedMessage) {
      setShowSuccess(true);
      setMessage(storedMessage);
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
      localStorage.removeItem('berhasilClockIn')
    }
    return () => {
      clearInterval(timerID);
    };
  }, []);
  const tick = () => {
    setTime(new Date());
  };
  const hours = time.getHours().toString().padStart(2, '0');
  const minutes = time.getMinutes().toString().padStart(2, '0');

  const handleClockIn = () => {
    navigate('/manager/karyawan/presensi/clockin');
  };

  const handleClockOut = () => {
    navigate('/manager/karyawan/presensi/clockout');
  };
  
  const handleLogout = () => {
    setOpenLogout(false);
    logout();
  };
  const drawerWidth = 300;

  return (
    <Box>
      <CssBaseline />
      <AdminNavigation />

      <Container
        component="main"
        maxWidth="xl"
      >
        <center>
          <Container component="main" maxWidth="sm">
            {showSuccess && (
              <Alert variant="filled" severity="success">
                {message}
              </Alert>
            )}
            <Typography fontSize={30} paddingTop={20}>
              {formattedDate}
            </Typography>
            <Typography fontSize={100}>{`${hours}:${minutes}`}</Typography>
            <form sx={{ width: "100%" }}>
              <Button
                type="submit"
                color="inherit"
                style={{
                  backgroundColor: "black",
                  color: "white",
                  margin: "3vw",
                  width: "10vw",
                }}
                onClick={handleClockIn}
              >
                Clock In
              </Button>
              <Button
                type="submit"
                color="inherit"
                style={{
                  backgroundColor: "black",
                  color: "white",
                  margin: "3vw",
                  width: "10vw",
                }}
                onClick={handleClockOut}
              >
                Clock Out
              </Button>
            </form>
          </Container>
        </center>
      </Container>
    </Box>
  );
};

export default PresensiManager;
